import WasteComposition from "./Components/WasteComposition";
import FutureWaste from "./Components/FutureWaste";
import WasteCard from "./Components/WasteCard";
import CostSavingsCard from "./Components/CostSavingsCard";
import FutureCostSavings from "./Components/FutureCostSavings";
import WasteCreated from "./Components/WasteCreated";
import {useState} from "react";
import FutureWasteForecast from "./Components/FutureWaste";
import WasteScenariosComponent from "./Components/WasteCard";


type Season = "summer" | "winter" | "spring" | "autumn"


const OthersPage = () => {

    const [selectedSeason, setSelectedSeason] = useState<Season>("summer")
    const [bins,  setBins] =  useState<string[]>([""])
    const [timeRange,  setTimeRange] =  useState("")

    return (
        <div className="container mx-auto p-3 sm:p-4 md:p-6">
            <div
                className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-3 sm:gap-4 md:gap-6 auto-rows-fr min-h-0">
                <WasteCreated selectedSeason={selectedSeason} bins={bins} timeRange={timeRange}/>
                <WasteComposition selectedSeason={selectedSeason} onSeasonChange={setSelectedSeason}/>
                <FutureWasteForecast/>
                <WasteScenariosComponent/>
                <FutureCostSavings/>
                <CostSavingsCard/>
            </div>
        </div>
    );
};

export default OthersPage;